export function getBrowseURL(url, hasOrganization, isLearningAiTypeNavItem = false) {
  if (hasOrganization && !isLearningAiTypeNavItem) {
    return `/organization/home${url}`;
  }
  return url;
}
//# sourceMappingURL=get-browse-url.js.map